import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLang } from "../context/LangContext";
import { pathFor } from "../lib/routes";
import { BRAND_INFO } from "../lib/content";

export default function Footer() {
  const { lang, t } = useLang();
  const p = (k) => pathFor(k, lang);
  return (
    <footer className="hairline-t bg-base mt-32" data-testid="footer">
      <div className="container-luxe py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/logos/riviera-shockwaves@4x.png"
            srcSet="/logos/riviera-shockwaves.png 300w, /logos/riviera-shockwaves@4x.png 1200w"
            sizes="228px"
            width="300"
            height="84"
            alt="Riviera Shockwaves"
            className="block h-16 w-auto mb-6"
            data-testid="footer-logo"
          />
          <p className="font-serif-luxe text-2xl md:text-3xl text-[var(--ink)] leading-snug max-w-md">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 flex items-center gap-5 opacity-80">
            <img src="/logos/exomobil.png" alt="Exomobil" className="h-8 w-auto logo-light" data-testid="footer-exomobil" />
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="overline mb-4">Nav</div>
          <ul className="space-y-2 text-sm text-[var(--ink)]/70 font-body">
            <li><Link to={p("treatments")} className="hover:text-[var(--gold)]" data-testid="footer-treatments">{t("nav.treatments")}</Link></li>
            <li><Link to={p("yacht")} className="hover:text-[var(--gold)]" data-testid="footer-yacht">{t("nav.yacht")}</Link></li>
            <li><Link to={p("villa")} className="hover:text-[var(--gold)]" data-testid="footer-villa">{t("nav.villa")}</Link></li>
            <li><Link to={p("booking")} className="hover:text-[var(--gold)]" data-testid="footer-booking">{t("nav.booking")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-[var(--ink)]/70 font-body">
            <li>Cala del Forte · Monaco · French Riviera</li>
            <li>contact@riviera-shockwaves.com</li>
            <li>+33 7 86 44 82 47</li>
            <li>
              <a href={BRAND_INFO.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors" data-testid="footer-instagram">
                <Instagram size={13} /> @rivierashockwaves
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="hairline-t">
        <div className="container-luxe py-6 text-[11px] uppercase tracking-[0.2em] font-display text-[var(--ink)]/40 flex items-center justify-between">
          <span>{t("footer.legal")}</span>
          <span>MC · FR</span>
        </div>
      </div>
    </footer>
  );
}
